import { PreLoginKcRealmVO } from '@repo/types'
import { Button, Hint, Input, Loading } from '@tecsinapse/cortex-react'
import React from 'react'
import { Controller } from 'react-hook-form'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import { MdOutlineMailOutline } from 'react-icons/md'
import { useStageEmail } from '../hooks'
import { stageEmailVariants } from '../styles'

interface StageEmailProps {
  realmParam: string | null
  setStage: (stage: string) => void
  setOptions?: (options: PreLoginKcRealmVO[]) => void
}

const { container, title, subtitle, iconHint, buttonLoading, icon } = stageEmailVariants()

const StageEmail = ({ setStage, setOptions, realmParam }: StageEmailProps) => {
  const { loading, discoveryRealmAndRedirect, form, onKeyDown } = useStageEmail({
    setOptions,
    setStage,
    realmParam
  })

  return (
    <div className={container()}>
      <div>
        <p className={title()}>Bem-vindo a plataforma Wingo</p>
        <p className={subtitle()}>Insira seu e-mail para prosseguir com o login no sistema</p>
      </div>
      <Controller
        name={'mail'}
        control={form.control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <div>
            <Input.Face>
              <Input.Left className={icon()}>
                <MdOutlineMailOutline />
              </Input.Left>
              <Input.Box
                placeholder='E-mail'
                label='E-mail'
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
              />
            </Input.Face>

            {error && (
              <Hint
                variants={{
                  intent: 'error'
                }}
              >
                <div className={iconHint()}>
                  <IoIosCloseCircleOutline />
                  <p>{error.message}</p>
                </div>
              </Hint>
            )}
          </div>
        )}
      />

      <div>
        <Button
          variants={{ intent: 'primary' }}
          onClick={discoveryRealmAndRedirect}
        >
          <>
            {loading ? (
              <div className={buttonLoading()}>
                <Loading className={'flex items-center'} />
                <p>Carregando</p>
              </div>
            ) : (
              'Prosseguir'
            )}
          </>
        </Button>
      </div>
    </div>
  )
}

export default StageEmail
